export enum ValidateMemberResponseCodesEnum {
  DOCUMENT_NOT_FOUND = 'VM0',
  MEMBER_INACTIVE = 'VM1',
  MEMBER_DONT_HAVE_EMAIL = 'VM2',
  SUCCESS = 'VM3',
  USER_ALREADY_EXISTS = 'VM4',
  VALIDATION_ERROR = 'VM500',
  ANP_ERROR = 'VM5'
}

export enum ResendVerificationCodeResponseCodesEnum {
  DOCUMENT_DOESNT_MATCH = 'RC01',
  MEMBER_ALREADY_ACTIVE = 'RC02',
  UNEXPECTED_ERROR = 'RC03',
  COULDNT_SEND_CODE = 'RC04',
}

export enum LoginResponseCodesEnum {
  DOCUMENT_NOT_FOUND = 'VM0',
  MEMBER_INACTIVE = 'VM1',
  MEMBER_DOESNT_HAVE_EMAIL = 'VM3',
  BAD_REQUEST = 'L01',
  USER_DOESNT_EXIST = 'L02',
  WRONG_PASSWORD = 'L03',
  SUCCESS = 'null',
  USER_INACTIVE = 'L04',
  ANP_ERROR = 'VM5'
}

export enum SignUpResponseCodesEnum {
  SUCCESS = 'null',
  DOCUMENT_NOT_FOUND = 'VM0',
  MEMBER_INACTIVE = 'VM1',
  CARNET_DOESNT_MATCH = 'VM2',
  CARNET_ALREADY_EXISTS = 'VM4',
  USER_ALREADY_EXISTS = 'S02',
  PASSWORDS_DONT_MATCH = 'S03',
  PASSWORD_TOO_SHORT = 'S04',
  ERROR_SAVING_USER = 'S05',
  UNEXPECTED_ERROR = 'S06',
  ANP_ERROR = 'VM5',
  COULDNT_SEND_SMS = 'RC04'
}

export enum ForgotPasswordResponseCodesEnum {
  DOCUMENT_NOT_FOUND = 'VM0',
  MEMBER_INACTIVE = 'VM1',
  EMAIL_DOESNT_MATCH = 'VM2',
  SUCCESS = 'null',
  EMAIL_NOT_FOUND = 'FP01',
  EMAIL_NOT_SENT = 'FP02',
  UNEXPECTED_ERROR = 'FP03',
  ANP_ERROR = 'VM5'
}
